(function(window, app, overwatch, _){
	var media = {};
	media.init = function init(mediaByCategory, id) {
		overwatch.menuScroll.init({
			menuSelector: "#sub-nav-menu",
			timeToHideMs: 5000,
		});
		this.setupGallery(mediaByCategory);
		this.setupHistoryStates();
		if(typeof id === "string" && id.length !== 0) {
			this.loadMedia(id);
		}
	};

    media.addGallery = function(context) {
        context = context || $(document.body);
        $('[data-js-media-gallery]', context).each(function(){
            overwatch.gallery.create({ elem: this, id: $(this).data('js-media-gallery') });
        });
    };

	media.setupGallery = function(mediaByCategory) {
		_.each(mediaByCategory, function(collection, category){
			var gallery = overwatch.gallery.get(category);
			_.each(collection, function(media){
				gallery.add(media);
			})
		});
	};

	media.setupHistoryStates = function() {
		$(document.body).on("ow.mediagallery.open", function(e, data) {
			var currentId = window.history.state ? window.history.state.media_id : "";
			if(data.id !== currentId) {
				window.history.replaceState({media_id: data.id}, null, data.id);
			}
		});
	};

	media.loadMedia = function(id) {
		var container = $("[data-media-id="+id+"]");
		var item = container.find("[data-js=media-gallery-content]");
		if(item.length > 0){
			item[0].scrollIntoView();
			item.trigger('open');
		}
	};
	app.extend({ media: media });
}(window, window.app, window.overwatch, window._));
